import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuoteComponent } from './quote.component';
import { PhoneNumberModule } from '@schoolbelle/common/phone-number';

@NgModule({
  declarations: [QuoteComponent],
  imports: [
    CommonModule,
    PhoneNumberModule.forRoot(),
  ],
  exports:[QuoteComponent]
})
export class QuoteModule { }
